import { CustomerDisplayConfigurationDTO, CustomerDisplayType, SaleDTO, TicketDTO, TicketLineDTO } from 'core/api';
import { Display } from './Display';
import nullDisplay from './NullDisplay';
import screenDisplay from './ScreenDisplay';
import serialPortDisplay from './SerialPortDisplay';

let display: Display = nullDisplay;

export async function configure(configuration: CustomerDisplayConfigurationDTO) {
	switch (configuration.DisplayType) {
		case CustomerDisplayType.Screen:
			await screenDisplay.show(configuration);
			display = screenDisplay;
			break;
		case CustomerDisplayType.Serie:
			display = serialPortDisplay;
			break;
		case CustomerDisplayType.None:
			display = nullDisplay;
			break;
		default: throw Error(`El tipo de visor ${configuration.DisplayType} es desconocido`);
	}
}


export async function clear(): Promise<void> {
	await display.clear();
}

export async function displayTotal(amount: number): Promise<void> {
	await display.displayTotal(amount);
}

export async function displayTicketTotal(ticket: TicketDTO): Promise<void> {
	await display.displayTicketTotal(ticket);
}

export async function displayOffers(ticket: TicketDTO): Promise<void> {
	await display.displayOffers(ticket);
}

export async function displaySale(sale: SaleDTO): Promise<void> {
	await display.displaySale(sale);
}

export async function displayNewLine(ticket: TicketDTO, line: Nullable<TicketLineDTO>): Promise<void> {
	if (line == null)
		return;

	await display.displayNewLine(ticket, line);
}

export async function displayExistingLine(ticket: TicketDTO, line: Nullable<TicketLineDTO>): Promise<void> {
	if (line == null)
		return;

	await display.displayExistingLine(ticket, line);
}

export async function displayRemovedLine(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
	await display.displayRemovedLine(ticket, line);
}

export async function displayLineDiscountPercentage(ticket: TicketDTO, line: Nullable<TicketLineDTO>): Promise<void> {
	if (line == null)
		return;

	await display.displayLineDiscountPercentage(ticket, line);
}

export async function displayLineCashDiscount(ticket: TicketDTO, line: Nullable<TicketLineDTO>): Promise<void> {
	if (line == null)
		return;

	await display.displayLineCashDiscount(ticket, line);
}

export async function displayDiscounts(ticket: TicketDTO): Promise<void> {
	await display.displayDiscounts(ticket);
}

export async function displayClosedCashdrawer(): Promise<void> {
	await display.displayClosedCashdrawer();
}

export async function displayLineNote(ticket: TicketDTO, line: Nullable<TicketLineDTO>): Promise<void> {
	if (line == null)
		return;

	await display.displayLineNote(ticket, line);
}

export async function displayWeight(kgs: number, pricePerKgs: number, total: number): Promise<void> {
	await display.displayWeight(kgs, pricePerKgs, total);
}

export async function displayCustomer(ticket: TicketDTO): Promise<void> {
	await display.displayCustomer(ticket);
}

export async function displayPriceList(ticket: TicketDTO): Promise<void> {
	await display.displayPriceList(ticket);
}

export async function displayServiceCharge(ticket: TicketDTO): Promise<void> {
	await display.displayServiceCharge(ticket);
}